import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/healthPlan/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getList1 = (id) => {
  return request({
    url: '/health/healthPlan/list1',
    method: 'get',
    params: {
      id
    }
  })
}

export const getList2 = (current, size, params) => {
  return request({
    url: '/health/healthPlan/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (current, size, params) => {
  return request({
    url: '/health/healthPlan/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/healthPlan/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/healthPlan/submit',
    method: 'post',
    data: row
  })
}

export const getDurg = (id) => {
  return request({
    url: '/health/drugManagement/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const getListUDP = (wxUserId) => {
  return request({
    url: '/health/userDrugPlan/list',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getDetailUDP = (current, size, params) => {
  return request({
    url: '/health/userDrugPlan/detail',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const removeUDP = (ids) => {
  return request({
    url: '/health/userDrugPlan/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submitUDP = (row) => {
  return request({
    url: '/health/userDrugPlan/submit',
    method: 'post',
    data: row
  })
}

